export default function isInFuture(date) {
  return date > new Date()
}
